import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
  IconNames,
} from '@dixa/lib-shared-habla';
import type { SearchFilterCondition } from 'lib-shared-types-api';
import { Fragment } from 'react';

import { useSearchFilters } from '../../../../searchFilters.context';

type ConditionActionsProps = {
  index: number;
  condition: SearchFilterCondition;
};

type ConditionAction = {
  text: string;
  icon: IconNames;
  divider?: boolean;
  actionFn: VoidFunction;
};

/**
 * Represents a component that can be used to add, duplicate or remove
 * conditions for a filter
 */
export const ConditionActions = ({
  index,
  condition,
}: ConditionActionsProps): JSX.Element => {
  const { copyCondition, removeCondition } = useSearchFilters();

  const actions: ConditionAction[] = [
    {
      text: 'Add another',
      icon: 'plus',
      actionFn: () => copyCondition(index, condition, { fullCopy: false }),
    },
    {
      text: 'Duplicate',
      icon: 'copy',
      actionFn: () => copyCondition(index, condition, { fullCopy: true }),
    },
    {
      text: 'Remove',
      icon: 'trash',
      divider: true,
      actionFn: () => removeCondition(index),
    },
  ];

  return (
    <DropdownButton
      icon="dots-v"
      buttonProps={{ variant: 'tertiary' }}
      fixed
      noArrow
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              <ButtonList>
                {actions.map(
                  ({ text, icon, divider = false, actionFn }, index) => (
                    <Fragment key={index}>
                      {divider && <ButtonList.Divider />}

                      <ButtonList.Item
                        icon={icon}
                        onClick={() => {
                          actionFn();
                          toggleDropdown();
                        }}
                      >
                        {text}
                      </ButtonList.Item>
                    </Fragment>
                  ),
                )}
              </ButtonList>
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    />
  );
};
